import * as ActionTypes from 'actions/beneficiaryForm'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
}

// Updates error message to notify about the failed fetches.
export default function beneficiaryForm(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BENEFICIARY_SAVE_REQUEST:
      return Object.assign({}, state, {
      })
    case ActionTypes.BENEFICIARY_SAVE_COMPLETE:
      return {
        ...state,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/beneficiaryForm.js